// extracted by mini-css-extract-plugin
export default {"subprojectsContainer":"msHGw","subprojectListContainer":"TJmCa"};